import React, { useEffect } from "react";
import * as THREE from "three";
import { useRef } from "react";
import { RGBShiftShader } from "three/examples/jsm/shaders/RGBShiftShader.js";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass.js";
import { FilmPass } from "three/examples/jsm/postprocessing/FilmPass.js";
import WebGL from "three/addons/capabilities/WebGL.js";

import modeloPath1 from '../../recursos/grid.webp';
import modeloPath2 from '../../recursos/displacementmap2.png';
import modeloPath3 from '../../recursos/emissionmap_2.png';
import modeloPath4 from '../../recursos/Starfield.png';
import modeloPath5 from '../../recursos/sun.webp';

const Three = ({ speedAnimationRef }) => {
  const canvasRef = useRef(null); // Creamos una referencia para el canvas
  const clock = new THREE.Clock();
  const planeZRange = 2; // Rango en el que los planos se mueven en Z
  useEffect(() => {
    // Verificamos si WebGL está disponible en el navegador
    if (!WebGL.isWebGLAvailable()) {
      const warning = WebGL.getWebGLErrorMessage();
      document.getElementById("container").appendChild(warning);
    }



    // Definimos colores para la escena
    const PINK = "#1d4e8c"; // Color para los focos
    const WHITE = "#1d4e8c"; // Color de luz ambiental
    const INDIGO = "#1d4e8c"; // Otro color para los focos

    // Cargamos texturas
    const TEXTURE = modeloPath1;
    const TERRAIN = modeloPath2;
    const SHINY = modeloPath3;
    const SKYBOX = modeloPath4;

    const textureLoader = new THREE.TextureLoader();
    const gridLandscape = textureLoader.load(TEXTURE); // Cargamos textura del plano
    const terrain = textureLoader.load(TERRAIN); // Cargamos textura del terreno
    const shinystuff = textureLoader.load(SHINY); // Cargamos textura de materiales brillantes
    const sky = textureLoader.load(SKYBOX); // Cargamos textura del cielo

    const canvas = canvasRef.current;
    const scene = new THREE.Scene(); // Creamos la escena
    //scene.background = sky; // Asignamos el fondo del cielo

    // Definimos la geometría del plano
    const geometry = new THREE.PlaneGeometry(3.5, 2, 194, 194); //1.5, 2,24,24  las ultimos 2 datos entre mas grande mas curvas tendra el terreno


    //hace mas chicos los cuadros del grid
    gridLandscape.wrapS = gridLandscape.wrapT = THREE.RepeatWrapping;
    gridLandscape.repeat.set(18, 18); // Ajusta la cantidad de repeticiones

    // Creamos un material para el plano usando las texturas cargadas
    /*const material = new THREE.MeshStandardMaterial({
      map: gridLandscape,
      displacementMap: terrain,
      displacementScale: 0.25, //entre mas grande mas alto las montañas
      metalnessMap: shinystuff,
      metalness: 1,
      roughness: 1.0, //entre mas da mas luz
    });*/

    //terreno plano
    /*
    const material = new THREE.ShaderMaterial({
  uniforms: {
    map: { value: gridLandscape },
    displacementMap: { value: terrain },
    displacementScale: { value: 0.25 },
    emissiveMap: { value: shinystuff },
    emissive: { value: new THREE.Color(0x1d4e8c) },
    emissiveIntensity: { value: 6.0 },
    color: { value: new THREE.Color("#191416") },
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D map;
    uniform sampler2D displacementMap;
    uniform float displacementScale;
    uniform sampler2D emissiveMap;
    uniform vec3 emissive;
    uniform float emissiveIntensity;
    uniform vec3 color;
    
    varying vec2 vUv;
    
    void main() {
      vec4 baseColor = texture2D(map, vUv);
      vec4 displacement = texture2D(displacementMap, vUv);
      vec4 emissiveColor = texture2D(emissiveMap, vUv);
      vec3 finalColor = mix(color, baseColor.rgb, baseColor.a);
      gl_FragColor = vec4(finalColor * emissive * emissiveIntensity, baseColor.a);
    }
  `,
});
    */


    //terreno con montañas
    const material = new THREE.MeshStandardMaterial({
      map: gridLandscape, // Textura difusa o base
      displacementMap: terrain, // Textura de desplazamiento
      displacementScale: 0.25,
      emissiveMap: shinystuff, // Textura de emisión
      
      emissive: new THREE.Color(0x1d4e8c), // Color blanco para máxima luminosidad
      emissiveIntensity: 6.0, // Ajusta la intensidad de la emisión
      metalness: 0.5, // Valor base de metalicidad
      roughness: 1.0,
    //  color: new THREE.Color('#ffffff')
    });




    /*
        // Creamos una esfera que representará el sol
        const sunGeometry = new THREE.SphereGeometry(1, 32, 32);
        const sunMaterial = new THREE.MeshStandardMaterial({
          map: textureLoader.load(modeloPath5),
        });
        const sun = new THREE.Mesh(sunGeometry, sunMaterial);
        sun.position.set(0, 0.5, -3.5); // Posicionamos la esfera
        scene.add(sun);
    
        // Agregamos una luz direccional para simular la luz solar
        const sunLight = new THREE.DirectionalLight("#DDDDDD", 1.25);
        sunLight.position.set(0, 1, -1.5);
        scene.add(sunLight);*/

    // Creamos tres planos y los agregamos a la escena
    const plane1 = new THREE.Mesh(geometry, material);
    const plane2 = new THREE.Mesh(geometry, material);
    const plane3 = new THREE.Mesh(geometry, material);

    // Ajustamos la rotación y posición de los planos
    plane1.rotation.x = -Math.PI * 0.5;
    plane1.position.z = 0.15;

    plane2.rotation.x = -Math.PI * 0.5;
    plane2.position.z = -1.85;

    plane3.rotation.x = -Math.PI * 0.5;
    plane3.position.z = -3.85;

    scene.add(plane1, plane2, plane3);

    // Agregamos una luz ambiental a la escena
    const ambientLight = new THREE.AmbientLight(WHITE, 11);
    scene.add(ambientLight);

    // Creamos y posicionamos dos focos con los colores PINK e INDIGO
    const spotlight1 = new THREE.SpotLight(PINK, 90, 15, Math.PI * 0.1, 0.25);
    spotlight1.position.set(-1, 0.5, 2.5);
    scene.add(spotlight1, spotlight1.target);

    const spotlight2 = new THREE.SpotLight(INDIGO, 200, 15, Math.PI * 0.1, 0.25);
    spotlight2.position.set(1, 0.5, 2.5);
    scene.add(spotlight2, spotlight2.target);

    // Creamos la cámara con una perspectiva ajustada al tamaño del canvas
    const camera = new THREE.PerspectiveCamera(
      85,
      canvas.clientWidth / canvas.clientHeight,
      0.01,
      10
    );
    camera.position.set(0, 0.12, 1); //altura de la camara datos 2

    // Creamos el renderer y lo ajustamos al tamaño del canvas
    const renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      alpha: true, // Habilita el soporte de transparencia
    });
    
    renderer.setSize(canvas.clientWidth, canvas.clientHeight);
    renderer.setPixelRatio(window.devicePixelRatio);
    //renderer.setClearColor('#171120'); //color del background

    // Creamos un EffectComposer para manejar postprocesado de efectos
    const effectComposer = new EffectComposer(renderer);
    effectComposer.setSize(canvas.clientWidth, canvas.clientHeight);
    effectComposer.setPixelRatio(window.devicePixelRatio);

    // Agregamos el renderPass para renderizar la escena normal
    const renderPass = new RenderPass(scene, camera);
    effectComposer.addPass(renderPass);

    // Agregamos un efecto de desplazamiento RGB
    const rgbShiftPass = new ShaderPass(RGBShiftShader);
    rgbShiftPass.uniforms["amount"].value = 0.0007;
    effectComposer.addPass(rgbShiftPass);

    // Agregamos un efecto de bloom (brillo)
    const bloomPass = new UnrealBloomPass(
      new THREE.Vector2(canvas.clientWidth, canvas.clientHeight),
      0.9,
      0.5,
      0.85
    );
    bloomPass.strength = 0.25;
    bloomPass.threshold = 0;
    bloomPass.radius = 1;
    effectComposer.addPass(bloomPass);

    // Agregamos un efecto de película para darle un aspecto de ruido
    const filmPass = new FilmPass(0.4, 0.75, 2048, false);
    effectComposer.addPass(filmPass);

    // Función para ajustar el tamaño del renderer cuando se redimensiona la ventana
    const resizeRenderer = () => {
      camera.aspect = canvas.clientWidth / canvas.clientHeight;
      camera.updateProjectionMatrix();

      renderer.setSize(canvas.clientWidth, canvas.clientHeight);
      effectComposer.setSize(canvas.clientWidth, canvas.clientHeight);
    };

    window.addEventListener("resize", resizeRenderer);

    // Configuramos el reloj para la animación
    const updateFrame = () => {
      const deltaTime = clock.getDelta(); // Tiempo en segundos desde el último frame
      const animationSpeed = speedAnimationRef.current;

      // Calcula el desplazamiento en función del tiempo transcurrido y la velocidad
      const displacement = deltaTime * animationSpeed;

      // Mueve los planos en Z
      plane1.position.z += displacement;
      plane2.position.z += displacement;
      plane3.position.z += displacement;

      // Reposiciona los planos si salen del rango visible
      if (plane1.position.z > planeZRange) {
        plane1.position.z = plane3.position.z - planeZRange;
      }
      if (plane2.position.z > planeZRange) {
        plane2.position.z = plane1.position.z - planeZRange;
      }
      if (plane3.position.z > planeZRange) {
        plane3.position.z = plane2.position.z - planeZRange;
      }

      // Renderiza la escena con los efectos
      effectComposer.render();
      window.requestAnimationFrame(updateFrame);
    };



    updateFrame();

    // Limpiamos recursos cuando el componente se desmonta
    return () => {
      renderer.dispose();
      effectComposer.dispose();
      window.removeEventListener("resize", resizeRenderer);
    };
  }, [speedAnimationRef]);

  // Devolvemos el canvas donde se renderiza la escena 3D
  return <canvas ref={canvasRef} className="webGL" style={{ width: "100%", height: "100%" }}></canvas>;
};

export default Three;
